import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import config from "./config/config";

const CACHE_PREFIX = "translations_";
const CACHE_TTL = 100 * 60 * 1000; // 10 minutes

export async function initI18n(companyId, forceReload = false) {
  const lng = "en";
  const cacheKey = `${CACHE_PREFIX}${companyId}_${lng}`;
  const cacheTimeKey = `${cacheKey}_time`;

  const cachedData = localStorage.getItem(cacheKey);
  const cachedTime = localStorage.getItem(cacheTimeKey);
  const now = Date.now();

  let translations = null;

  // ✅ If valid cache & not forcing reload
  if (
    !forceReload &&
    cachedData &&
    cachedTime &&
    now - parseInt(cachedTime, 10) < CACHE_TTL
  ) {
    try {
      translations = JSON.parse(cachedData);
   //   console.log("🗂 Using cached translations");
    } catch {
      translations = null;
    }
  }

  // 🚀 Otherwise fetch new ones
  if (!translations) {
    try {
      const url = `${config.apiBaseUrl}/auth/translations/${companyId}/${lng}.json?ts=${now}`;
      const res = await fetch(url);
      if (res.ok) {
        translations = await res.json();
        localStorage.setItem(cacheKey, JSON.stringify(translations));
        localStorage.setItem(cacheTimeKey, now.toString());
      //  console.log("✅ Translations fetched & cached");
      } else {
        console.error("Failed to load translations:", res.status);
      }
    } catch (err) {
      console.error("Translation fetch error:", err);
    }
  }

  // ✅ Always (re)initialize when forceReload is true
  if (!i18n.isInitialized || forceReload) {
    await i18n.use(initReactI18next).init({
      resources: translations ? { [lng]: { translation: translations } } : {},
      lng,
      fallbackLng: "en",
      interpolation: { escapeValue: false },
      debug: false,
    });
  } else if (translations) {
    // 🔁 Update existing instance dynamically
    i18n.addResources(lng, "translation", translations);
  }

  return i18n;
}

export default i18n;
